"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CardSection = _interopRequireDefault(require("../../../structure/CardSection"));

var _pclnDesignSystem = require("pcln-design-system");

var _FormatPrice = require("../../../../utils/FormatPrice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Footer = (0, _styledComponents["default"])(_CardSection["default"]).withConfig({
  componentId: "cbd1t2-0"
})(["background-color:", ";"], function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.backgroundColor)(props);
});

function SummaryOfChargesFooter(_ref) {
  var className = _ref.className,
      title = _ref.title,
      amount = _ref.amount,
      prefixText = _ref.prefixText,
      suffixText = _ref.suffixText,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      footnoteSymbol = _ref.footnoteSymbol;
  return _react["default"].createElement(Footer, {
    className: className,
    backgroundColor: backgroundColor
  }, _react["default"].createElement(_pclnDesignSystem.Flex, {
    alignItems: "center",
    justifyContent: "space-between"
  }, _react["default"].createElement(_pclnDesignSystem.Text, {
    bold: true,
    color: textColor,
    fontSize: 1
  }, title), _react["default"].createElement(_pclnDesignSystem.Flex, null, _react["default"].createElement(_pclnDesignSystem.Text, {
    bold: true,
    color: textColor,
    fontSize: 1
  }, prefixText, typeof amount === 'string' ? amount : (0, _FormatPrice.formatPrice)((amount || 0).toFixed(2)), " ", suffixText), footnoteSymbol && _react["default"].createElement(_pclnDesignSystem.Text, {
    color: textColor,
    fontSize: footnoteSymbol === '*' ? 2 : '10px'
  }, footnoteSymbol))));
}

SummaryOfChargesFooter.displayName = 'SummaryOfChargesFooter';
SummaryOfChargesFooter.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  amount: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  prefixText: _propTypes["default"].string,
  suffixText: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  footnoteSymbol: _propTypes["default"].string
};
SummaryOfChargesFooter.defaultProps = {
  className: '',
  textColor: '#697886',
  backgroundColor: '#f2f2f2'
};

var _default = (0, _react.memo)(SummaryOfChargesFooter);

exports["default"] = _default;